import { FatUserQuery } from "./user.ts"

export function useConfig() {
	const fatUser = FatUserQuery.use().data
	return fatUser?.appConfig!
}
